<template>
  <v-container fluid pa-0>
    <v-layout row wrap>
      <v-flex md12 sm12 xs12 ma-2>
        <v-layout row wrap></v-layout>
        <v-layout row wrap class="hidden-xs-only content">
          <v-flex xs12></v-flex>
        </v-layout>
      </v-flex>
      <!-- List -->
      <v-flex md12 sm12 xs12>
        <v-layout row wrap>
          <v-layout row wrap>
            <v-container fluid pt-3 style="border-right:0px;border-left:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;">
              <v-layout row wrap>
                <v-flex md12 sm12 xs12 class="hidden-sm-and-up" v-if="listpersondetail.length > 0">
                  <!-- ไม่แสดงขนาดกลางและขนาดใหญ๋ -->
                  <v-expansion-panel expand>
                    <v-expansion-panel-content
                      style="background-color:#ffffff;margin:0px;"
                      v-for="(item, i) in listpersondetail"
                      :key="i"
                      expand-icon
                      id="listpersondetail"
                      :checkboxperson="checkboxperson"
                    >
                      <div slot="header">
                        <v-card class="coco-box-shadow">
                          <v-layout align-center justify-center row fill-height wrap>
                            <!-- ปุ่ม payslip หน้าจอเล็ก -->
                            <v-flex lg2 md2 sm2 xs12 text-xs-right>
                              <v-layout row wrap>
                                <v-flex offset-lg5 offset-md3 lg3 md4 xs6></v-flex>
                                <v-flex lg3 md4 xs6>
                                  <v-tooltip bottom>
                                    <v-btn slot="activator" color="green" icon flat @click="showPayslip(item.docNo, item.code)">
                                      <v-icon>fas fa-print</v-icon>
                                    </v-btn>
                                    <span>{{ $t("PaySlip") }}</span>
                                  </v-tooltip>
                                  <v-tooltip bottom>
                                    <v-btn slot="activator" color="error" icon flat @click="emailPayslip(item.code, i)">
                                      <v-icon class="mr-2">fas fa-envelope-open-text</v-icon>
                                    </v-btn>
                                    <span>{{ $t("SendPayslip") }}</span>
                                  </v-tooltip>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex lg1 md1 sm2 xs4 text-xs-center>
                              <v-icon style="font-size: 50px">fas fa-file-invoice-dollar</v-icon>
                              <!-- <v-checkbox
                                v-model="checkboxperson"
                                :value="item.docNo"
                                :label="`${dateformat(item.createDateTime)}`"
                                @change="select()"
                              ></v-checkbox>-->
                            </v-flex>
                            <v-flex lg9 md9 sm8 xs8>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12 class="hidden-xs-only content" style="margin-top:-20px">
                                  <span class="coco-list-label-text content">{{ item.docNo }} :</span>
                                  <!-- <span>{{item.name}}</span> -->

                                  <span style="padding-right:20px;color:#000000">{{ dateformat(item.processTimes[item.processTimes.length - 1].date) }}</span>
                                  <span style="color:green;padding-right:2px;">{{ thousandSep(item.total_balance) }}</span>
                                </v-flex>

                                <v-flex lg12 md12 sm12 xs12 class="hidden-sm-and-up">
                                  <v-flex></v-flex>
                                  <span class="coco-list-label-text content">{{ item.docNo }} :</span>
                                  <!-- <span class="coco-list-label-text content">{{item.code}} :</span> -->
                                  <br />
                                  <!-- <span>{{item.name}}</span> -->
                                  <span style="padding-right:20px;color:#000000">{{ dateformat(item.processTimes[item.processTimes.length - 1].date) }} &nbsp;</span>
                                  <br />
                                  <span style="color:green;padding-right:2px;">{{ thousandSep(item.total_balance) }}</span>
                                </v-flex>

                                <v-flex lg12 md12 sm12 xs12>
                                  <v-layout row wrap>
                                    <v-flex lg2 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span class="coco-list-label-text">
                                        {{ $t("Salary") + " : " }}
                                        <span>{{ thousandSep(item.salary) }}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex lg2 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span class="coco-list-label-text">
                                        {{ $t("Totalincome") + " : " }}
                                        <span>{{ thousandSep(item.totalEarning) }}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex lg2 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span class="coco-list-label-text">
                                        {{ $t("Deductions") + " : " }}
                                        <span>{{ item.totalDeduct }}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex lg6 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span v-if="item.paymentType == 0" class="coco-list-label-text hidden-xs-only">
                                        {{ item.bankName }} :
                                        <span>
                                          {{ isEmpty(item.bankCode) ? item.bankCode : "bankCode" }}
                                        </span>
                                      </span>
                                      <span v-if="item.paymentType == 1" class="coco-list-label-text hidden-xs-only">
                                        {{ $t("Prompay") + ":" }}
                                        <span>
                                          {{ isEmpty(item.promptpayNumber) ? item.promptpayNumber : "promptpayNumber" }}
                                        </span>
                                      </span>
                                      <span v-if="item.paymentType == 2" class="coco-list-label-text hidden-xs-only">เงินสด</span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>

                                <v-flex lg12 md12 sm12 xs12>
                                  <v-layout row wrap>
                                    <v-flex xs12 class="hidden-sm-and-up">
                                      <span class="coco-list-label-text">
                                        {{ $t("Salary") + " : " }}
                                        <span>{{ thousandSep(item.salary) }}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex xs12 class="hidden-sm-and-up">
                                      <span class="coco-list-label-text">
                                        {{ $t("Totalincome") + " : " }}
                                        <span>{{ thousandSep(item.totalEarning) }}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex xs12 class="hidden-sm-and-up">
                                      <span class="coco-list-label-text">
                                        {{ $t("Deductions") + " : " }}
                                        <span>{{ item.totalDeduct }}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex xs12 class="hidden-sm-and-up">
                                      <span v-if="item.paymentType == 0" class="coco-list-label-text">
                                        {{ item.bankName }} :
                                        <span>
                                          {{ isEmpty(item.bankCode) ? item.bankCode : "bankCode" }}
                                        </span>
                                      </span>
                                      <span v-if="item.paymentType == 1" class="coco-list-label-text">
                                        {{ $t("Prompay") + ":" }}
                                        <span>
                                          {{ isEmpty(item.promptpayNumber) ? item.promptpayNumber : "promptpayNumber" }}
                                        </span>
                                      </span>
                                      <span v-if="item.paymentType == 2" class="coco-list-label-text">เงินสด</span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </div>

                      <v-card-text class="coco-box-shadow">
                        <!-- เพิ่มใหม่แสดงวันที่เริ่มงาน hidden-sm-only -->
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg7 md7 sm7 xs12>
                            <!-- <span class="coco-list-label-text hidden-sm-only">
                              {{$t('StartworkingDate') + ' : '}}
                              <span>{{item.startWorkingDate}}</span>
                            </span>-->
                            <span class="coco-list-label-text hidden-sm-only">
                              {{ $t("WorkingDate") + " : " }}
                              <span>{{ item.workingDate }}</span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <!-- <span class="coco-list-label-text hidden-sm-only">
                              {{$t('WorkingDate') + ' : '}}
                              <span>{{item.workingDate}}</span>
                            </span>-->
                          </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg7 md7 sm7 xs12>
                            <span v-if="item.empType == 0" class="hidden-sm-only" style="color:#B5B5B5;fontweight:400;padding:4px;">
                              {{ $t("Salary") }}:
                              <span style="color:green">
                                <!-- {{isEmpty(item.salary)? item.salary
                                : 'salary'}}-->
                                {{ thousandSep(item.salary) }}
                              </span>
                            </span>
                            <span v-else></span>
                            <span v-if="item.empType == 1" class="hidden-sm-only" style="color:#B5B5B5;fontweight:400;padding:4px;">
                              {{ $t("Perday") }}:
                              <!-- <span style="color:green">
                                {{isEmpty(item.perDay)? item.perDay.toFixed()
                                : 'Perday'}}
                              </span>-->
                            </span>
                            <span v-else></span>
                            <span v-if="item.empType == 2" class="hidden-sm-only" style="color:#B5B5B5;fontweight:400;padding:4px;">
                              {{ $t("Perhour") }}:
                              <!-- <span style="color:green">
                                {{isEmpty(item.perHour) ?
                                item.perHour.toFixed() : 'Perhour'}}
                              </span>-->
                            </span>
                            <span v-else></span>
                            <span v-if="item.deductAbsent == 0 || item.deductAbsent == null"></span>
                            <span v-else class="hidden-sm-only" style="color:#B5B5B5;padding:4px;">
                              ค่าฝีมือ:
                              <span style="color:green">
                                {{ isEmpty(item.deductAbsent) ? item.deductAbsent : "totaldeduct" }}
                              </span>
                            </span>
                            <span v-if="item.totalLeave == 0 || item.totalLeave == null"></span>
                            <span v-else class="hidden-sm-only" style="color:#B5B5B5;padding:4px;">
                              ค่าตำแหน่ง:
                              <span style="color:green">
                                {{ isEmpty(item.totalLeave) ? item.totalLeave : "totaldeduct" }}
                              </span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <!-- <span style="color:#B5B5B5">
                              รวมเงินได้ :
                              <span style="color:green;">{{thousandSep(item.salary)}}</span>
                            </span>-->
                          </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg7 md7 sm7 xs12>
                            <span v-if="item.totalOT == 0 || item.totalot == null"></span>
                            <span v-else class="hidden-sm-only" style="color:#B5B5B5;padding:4px;">
                              ชม.OT:
                              <span style="color:green">
                                {{ isEmpty(item.totalOT) ? item.totalOT : "totalOT" }}
                              </span>
                            </span>
                            <span v-if="item.totalOTEvent == 0 || item.totalOTEvent == null"></span>
                            <span v-else class="hidden-sm-only" style="color:#B5B5B5;padding:4px;">
                              เงินOT:
                              <span style="color:green">
                                {{ isEmpty(item.totalOTEvent) ? item.totalOTEvent : "totalOTEvent" }}
                              </span>
                            </span>
                            <span v-for="(items, j) in listpersondetail[i].incomeAndExpenses" :key="j">
                              <span v-if="items.tranFlag == 0" class="hidden-sm-only" style="color:#B5B5B5;padding:4px;">
                                {{ items.name }} :
                                <span class="hidden-sm-only" style="color:green;padding:4px;">
                                  {{ isEmpty(items.amount) ? items.amount : "amount" }}
                                </span>
                              </span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <span style="color:#B5B5B5;">
                              {{ $t("Totalincome") + ":" }}
                              <span style="color:green;">{{ thousandSep(item.totalEarning) }}</span>
                            </span>
                          </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg7 md7 sm7 xs12>
                            <span v-if="item.totalWorkhour == '0' || item.totalWorkhour == null"></span>
                            <span v-else class="hidden-sm-only" style="color:#B5B5B5;padding:4px;">
                              ชม ขาดงาน:
                              <span style="color:red;">
                                {{ isEmpty(item.totalWorkhour) ? item.totalWorkhour : "totalWorkhour" }}
                              </span>
                            </span>
                            <span v-if="item.totalAbsent == '0' || item.totalAbsent == null"></span>
                            <span v-else class="hidden-sm-only" style="color:#B5B5B5;padding:4px;">
                              หักเงินขาด:
                              <span style="color:red;">
                                {{ isEmpty(item.totalAbsent) ? item.totalAbsent : "totalAbsent" }}
                              </span>
                            </span>
                            <span v-for="(items, j) in listpersondetail[i].incomeAndExpenses" :key="j">
                              <span v-if="items.tranFlag == 1" class="coco-list-label-text hidden-sm-only">
                                {{ items.name }} :
                                <span style="color:red;">
                                  {{ isEmpty(items.amount) ? items.amount : "amount" }}
                                </span>
                              </span>
                            </span>

                            <span v-if="item.cumulativeSS == '0' || item.cumulativeSS == null"></span>
                            <span v-else class="hidden-sm-only" style="color:#B5B5B5;padding:4px;">
                              {{ $t("SocialSecurity") }}:
                              <span style="color:red;">
                                {{ isEmpty(item.cumulativeSS) ? item.cumulativeSS : "SocialSecurity" }}
                              </span>
                            </span>
                            <span v-if="item.deduct_tax <= 0 || item.deduct_tax == null"></span>
                            <span v-else class="hidden-sm-only" style="color:#B5B5B5;padding:4px;">
                              {{ $t("Tax") + ":" }}
                              <span style="color:red;">
                                {{ isEmpty(item.deduct_tax) ? item.deduct_tax : "totaldeduct" }}
                              </span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <span style="color:#B5B5B5;">
                              {{ $t("Totalexpenses") + ":" }}
                              <span style="color:red;">{{ thousandSep(item.totalDeduct) }}</span>
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
                <v-flex md12 sm12 xs12 class="hidden-sm-and-up" v-if="listpersondetail.length <= 0">
                  <v-flex xs12 md4 offset-md4 lg2 offset-lg5 class="adddoc-hover" style="cursor: pointer">
                    <v-layout row align-center text-xs-center style="margin-top:5rem;margin-bottom:15rem">
                      <v-flex xs12 md4 offset-md4 lg2 offset-lg5 class="adddoc-hover" style="cursor: pointer">
                        <div style="padding-top:40px;padding-bottom:40px;">
                          <h3 class="mb-0" style="color:#000;">คุณยังไม่มีเอกสารเงินเดือน</h3>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>
                <v-flex md12 sm12 xs12 class="hidden-xs-only content" v-if="listpersondetail.length > 0">
                  <v-expansion-panel expand>
                    <v-expansion-panel-content style="background-color:#ffffff" v-for="(item, i) in listpersondetail" :key="i" :checkboxperson="checkboxperson">
                      <div slot="header">
                        <v-card class="coco-box-shadow">
                          <v-layout align-center justify-center row fill-height wrap>
                            <v-flex lg1 md1 sm2 xs3 text-xs-center>
                              <v-icon style="font-size:50px">fas fa-file-invoice-dollar</v-icon>
                              <!-- <v-checkbox
                                v-model="checkboxperson"
                                :value="item.docNo"
                                :label="`${dateformat(item.createDateTime)}`"
                                @change="select()"
                              ></v-checkbox>-->
                            </v-flex>
                            <v-flex lg9 md9 sm8 xs6>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12 class="hidden-xs-only content">
                                  <span class="coco-list-label-text content">{{ item.docNo }} :</span>
                                  <span style="padding-right:20px;color:#000000">{{ dateformat(item.processTimes[item.processTimes.length - 1].date) }}</span>
                                  <span style="color:green;padding-right:2px;">{{ thousandSep(item.total_balance) }}</span>
                                </v-flex>

                                <v-flex lg12 md12 sm12 xs12 class="hidden-sm-and-up">
                                  <v-flex></v-flex>

                                  <br />

                                  <span style="padding-right:20px;color:#000000">{{ dateformat(item.processTimes[item.processTimes.length - 1].date) }}</span>
                                  <br />
                                  <span style="color:green;padding-right:2px;">{{ thousandSep(item.total_balance) }}</span>
                                </v-flex>

                                <v-flex lg12 md12 sm12 xs12>
                                  <v-layout row wrap>
                                    <v-flex lg2 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span class="coco-list-label-text">
                                        {{ $t("Salary") + " : " }}
                                        <span>{{ thousandSep(item.salary) }}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex lg2 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span class="coco-list-label-text">
                                        {{ $t("Totalincome") + " : " }}
                                        <span>{{ thousandSep(item.totalEarning) }}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex lg2 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span class="coco-list-label-text">
                                        {{ $t("Deductions") + " : " }}
                                        <span>{{ item.totalDeduct }}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex lg6 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span v-if="item.paymentType == 0" class="coco-list-label-text hidden-xs-only">
                                        {{ item.bankName }} :
                                        <span>
                                          {{ isEmpty(item.bankCode) ? item.bankCode : "bankCode" }}
                                        </span>
                                      </span>
                                      <span v-if="item.paymentType == 1" class="coco-list-label-text hidden-xs-only">
                                        {{ $t("Prompay") + ":" }}
                                        <span>
                                          {{ isEmpty(item.promptpayNumber) ? item.promptpayNumber : "promptpayNumber" }}
                                        </span>
                                      </span>
                                      <span v-if="item.paymentType == 2" class="coco-list-label-text hidden-xs-only">เงินสด</span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>

                                <v-flex lg12 md12 sm12 xs12>
                                  <v-layout row wrap>
                                    <v-flex xs12 class="hidden-sm-and-up">
                                      <span class="coco-list-label-text">
                                        {{ $t("Salary") + " : " }}
                                        <span>{{ thousandSep(item.salary) }}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex lg2 md6 sm6 xs6 class="hidden-sm-and-up">
                                      <span class="coco-list-label-text">
                                        {{ $t("Totalincome") + " : " }}
                                        <span>{{ thousandSep(item.totalEarning) }}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex xs12 class="hidden-sm-and-up">
                                      <span class="coco-list-label-text">
                                        {{ $t("Deductions") + " : " }}
                                        <span>{{ item.totalDeduct }}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex xs12 class="hidden-sm-and-up">
                                      <span v-if="item.paymentType == 0" class="coco-list-label-text">
                                        {{ item.bankName }} :
                                        <span>
                                          {{ isEmpty(item.bankCode) ? item.bankCode : "bankCode" }}
                                        </span>
                                      </span>
                                      <span v-if="item.paymentType == 1" class="coco-list-label-text">
                                        {{ $t("Prompay") + ":" }}
                                        <span>
                                          {{ isEmpty(item.promptpayNumber) ? item.promptpayNumber : "promptpayNumber" }}
                                        </span>
                                      </span>
                                      <span v-if="item.paymentType == 2" class="coco-list-label-text">เงินสด</span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <!-- แสดงหน้าจอใหญ่ -->
                            <v-flex lg2 md2 sm2 xs3 text-xs-right>
                              <v-layout row wrap>
                                <v-flex offset-lg5 offset-md3 lg3 md4 xs6>
                                  <v-tooltip bottom>
                                    <v-btn slot="activator" color="green" icon flat @click="showPayslip(item.docNo, item.code)">
                                      <v-icon style="font-size:25px">fas fa-print</v-icon>
                                    </v-btn>
                                    <span>{{ $t("PaySlip") }}</span>
                                  </v-tooltip>
                                </v-flex>
                                <v-flex lg3 md4 xs6>
                                  <v-tooltip bottom>
                                    <v-btn slot="activator" color="error" icon flat @click="emailPayslip(item.code, i)">
                                      <v-icon class="mr-2">fas fa-envelope-open-text</v-icon>
                                    </v-btn>
                                    <span>{{ $t("SendPayslip") }}</span>
                                  </v-tooltip>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </div>
                      <v-card-text class="coco-box-shadow">
                        <!-- เพิ่มใหม่ วันที่เริ่มงาน hidden-xs-only content-->
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg7 md7 sm7 xs12>
                            <!-- <span class="coco-list-label-text hidden-xs-only content">
                              {{$t('StartworkingDate') + ' : '}}
                              <span>{{item.startWorkingDate}}</span>
                            </span>-->
                            <span class="coco-list-label-text hidden-xs-only content">
                              {{ $t("WorkingDate") + " : " }}
                              <span>{{ item.workingDate }}</span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <!-- <span class="coco-list-label-text hidden-xs-only content">
                              {{$t('WorkingDate') + ' : '}}
                              <span>{{item.workingDate}}</span>
                            </span>-->
                          </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg7 md7 sm7 xs12>
                            <span v-if="item.empType == 0" class="hidden-xs-only content" style="color:#B5B5B5;fontweight:400;padding:4px;">
                              {{ $t("Salary") + " : " }}
                              <span style="color:green">{{ thousandSep(item.salary) }}</span>
                            </span>
                            <span v-else></span>
                            <span v-if="item.empType == 1" class="hidden-xs-only content" style="color:#B5B5B5;fontweight:400;padding:4px;">
                              {{ $t("Perday") + " : " }}
                              <!-- <span style="color:green">
                                {{isEmpty(item.perDay)? item.perDay.toFixed()
                                : 'Perday'}}
                              </span>-->
                            </span>
                            <span v-else></span>
                            <span v-if="item.empType == 2" class="hidden-xs-only content" style="color:#B5B5B5;fontweight:400;padding:4px;">
                              {{ $t("Perhour") + " : " }}
                              <!-- <span style="color:green">
                                {{isEmpty(item.perHour) ?
                                item.perHour.toFixed() : 'Perhour'}}
                              </span>-->
                            </span>
                            <span v-else></span>
                            <span v-if="item.deductAbsent == 0 || item.deductAbsent == null"></span>
                            <span v-else class="hidden-xs-only content" style="color:#B5B5B5;padding:4px;">
                              ค่าฝีมือ :
                              <span style="color:green">
                                {{ isEmpty(item.deductAbsent) ? item.deductAbsent : "totaldeduct" }}
                              </span>
                            </span>
                            <span v-if="item.totalLeave == 0 || item.totalLeave == null"></span>
                            <span v-else class="hidden-xs-only content" style="color:#B5B5B5;padding:4px;">
                              ค่าตำแหน่ง :
                              <span style="color:green">
                                {{ isEmpty(item.totalLeave) ? item.totalLeave : "totaldeduct" }}
                              </span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <!-- <span style="color:#B5B5B5">
                              รวมเงินได้ :
                              <span style="color:green;">{{thousandSep(item.salary)}}</span>
                            </span>-->
                          </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg7 md7 sm7 xs12>
                            <span v-if="item.totalOT == 0 || item.totalot == null"></span>
                            <span v-else class="hidden-xs-only content" style="color:#B5B5B5;padding:4px;">
                              ชม.OT :
                              <span style="color:green">
                                {{ isEmpty(item.totalOT) ? item.totalOT : "salary" }}
                              </span>
                            </span>
                            <span v-if="item.totalOTEvent == 0 || item.totalOTEvent == null"></span>
                            <span v-else class="hidden-xs-only content" style="color:#B5B5B5;padding:4px;">
                              เงินOT :
                              <span style="color:green">
                                {{ isEmpty(item.totalOTEvent) ? item.totalOTEvent : "salary" }}
                              </span>
                            </span>
                            <span v-for="(items, j) in listpersondetail[i].incomeAndExpenses" :key="j">
                              <span v-if="items.tranFlag == 0" class="hidden-xs-only content" style="color:#B5B5B5;padding:4px;">
                                {{ items.name }} :
                                <span style="color:green" class="hidden-xs-only content">{{ items.amount }}</span>
                              </span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <span style="color:#B5B5B5;">
                              {{ $t("Totalincome") + ":" }}
                              <span style="color:green;">{{ thousandSep(item.totalEarning) }}</span>
                            </span>
                          </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg7 md7 sm7 xs12>
                            <span v-if="item.totalWorkhour == '0' || item.totalWorkhour == null"></span>
                            <span v-else class="hidden-xs-only content" style="color:#B5B5B5;padding:4px;">
                              ชม ขาดงาน:
                              <span style="color:red;">
                                {{ isEmpty(item.totalWorkhour) ? item.totalWorkhour : "totalWorkhour" }}
                              </span>
                            </span>
                            <span v-if="item.totalAbsent == '0' || item.totalAbsent == null"></span>
                            <span v-else class="hidden-xs-only content" style="color:#B5B5B5;padding:4px;">
                              หักเงินขาด:
                              <span style="color:red;">
                                {{ isEmpty(item.totalAbsent) ? item.totalAbsent : "totalAbsent" }}
                              </span>
                            </span>
                            <span v-for="(items, j) in listpersondetail[i].incomeAndExpenses" :key="j">
                              <span v-if="items.tranFlag == 1" class="hidden-xs-only content" style="color:#B5B5B5;padding:4px;">
                                {{ items.name }} :
                                <span style="color:red;">
                                  {{ isEmpty(items.amount) ? items.amount : "amount" }}
                                </span>
                              </span>
                            </span>

                            <span v-if="item.cumulativeSS == '0' || item.cumulativeSS == null"></span>
                            <span v-else class="hidden-xs-only content" style="color:#B5B5B5;padding:4px;">
                              {{ $t("SocialSecurity") }} :
                              <span style="color:red;">
                                {{ isEmpty(item.cumulativeSS) ? item.cumulativeSS : "SocialSecurity" }}
                              </span>
                            </span>
                            <span v-if="item.deduct_tax <= 0 || item.deduct_tax == null"></span>
                            <span v-else class="hidden-xs-only content" style="color:#B5B5B5;padding:4px;">
                              {{ $t("Tax") + ":" }}
                              <span style="color:red;">
                                {{ isEmpty(item.deduct_tax) ? item.deduct_tax : "Tax" }}
                              </span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <span style="color:#B5B5B5;">
                              {{ $t("Totalexpenses") + ":" }}
                              <span style="color:red;">{{ thousandSep(item.totalDeduct) }}</span>
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
                <v-flex md12 sm12 xs12 class="hidden-xs-only content" v-if="listpersondetail.length <= 0">
                  <v-layout row align-center text-xs-center style="margin-top:5rem;margin-bottom:15rem">
                    <v-flex xs12 md4 offset-md4 lg2 offset-lg5 class="adddoc-hover" style="cursor: pointer">
                      <div style="padding-top:40px;padding-bottom:40px;">
                        <h3 class="mb-0" style="color:#000;">คุณยังไม่มีเอกสารเงินเดือน</h3>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-layout>
        </v-layout>
      </v-flex>
      <!-- FormDialog -->
      <v-snackbar v-model="snackbar" :timeout="3500" :top="'top'" :color="snackbarcolor">
        {{ snackmsg }}
        <v-btn dark flat @click="snackbar = false">X</v-btn>
      </v-snackbar>
    </v-layout>
    <v-layout row justify-center>
      <v-dialog v-model="docDialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t("Employee_payroll_doc") }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field readonly :label="$t('DocumentID')" required v-model="payroll_doc.doc_no"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field :label="$t('Document creation date')" type="date" v-model="payroll_doc.doc_date"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field :label="$t('fromdate')" readonly v-model="payroll_doc.begin_date"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field :label="$t('todate')" readonly v-model="payroll_doc.end_date"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field :label="$t('remark')" v-model="payroll_doc.remark"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="docDialog = false">ยกเลิก</v-btn>
            <v-btn color="blue darken-1" flat @click="saveDoc()">บันทึก</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="snackbar" :timeout="3500" :top="'top'" :color="snack_type">
        {{ snackmsg }}
        <v-btn dark flat @click="snackbar = false">X</v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import DocumentService from "@/services/DocumentService";
import ProcessService from "@/services/ProcessService";
import PayrollService from "@/services/PayrollService";
import Empimage from "../../components/getempimage.vue";
import SettingService from "@/services/SettingService";
import Utils from "@/utils/";
import XLSX from "xlsx";
import jsPDF from "jspdf";
import pdf from "vue-pdf";
import { constants } from "crypto";
import { chown } from "fs";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import $ from "jquery";
import moment from "moment";
export default {
  components: {
    pdf,
  },

  data: () => ({
    payroll_doc: {
      doc_no: "",
      doc_date: new Date().toISOString().substr(0, 10),
      begin_date: "",
      end_date: "",
      remark: "",
      creator_code: localStorage._usercode,
    },
    snackbarcolor: "red",
    docDialog: false,
    filterDialog: false,
    table_datalist: [],
    table_datalist_resign: [],
    table_head_model: {
      ชื่อ: "1",
      ประเภท: "1",
      ตำแหน่ง: "1",
      วันเริ่มทำงาน: "1",
      วันทำงานเดือนนี้: "1",
      เงินเดือน: "1",
      ค่าฝีมือ: "1",
      ค่าตำแหน่ง: "1",
      รวมเงินได้: "1",
      วันละ: "1",
      ชั่วโมงละ: "1",
      ชม_OT_รวม: "1",
      เงิน_OT_รวม: "1",
      รายละเอียดรายรับ: "1",
      รวมรายรับอื่นๆ: "1",
      วันหยุดพิเศษ: "1",
      รายได้วันหยุดพิเศษ: "1",
      รวมรายได้: "1",
      ชม_ลา_รวม: "1",
      หักเงินลา_รวม: "1",
      ลาไม่หักเงิน: "1",
      ชม_ขาด_รวม: "1",
      หักเงินขาด_รวม: "1",
      สาย_รวม: "1",
      หักเงินสาย_รวม: "1",
      ออกก่อน_รวม: "1",
      หักออกก่อน_รวม: "1",
      ประกันสังคม: "1",
      ภาษี: "1",
      รายละเอียดรายจ่าย: "1",
      รวมรายจ่ายอื่นๆ: "1",
      รวมหัก: "1",
      คงเหลือเงิน: "1",
      ประเภทการจ่ายเงิน: "1",
      เลขที่บัญชี: "1",
    },
    json_fields: {
      ชื่อ: "name",
      ประเภท: "empType",
      ตำแหน่ง: "position",
      วันเริ่มทำงาน: "startWorkingDate",
      วันทำงานเดือนนี้: "1",
      เงินเดือน: "salary",
      ค่าฝีมือ: "craftAmount",
      ค่าตำแหน่ง: "positionAmount",
      รวมเงินได้: "incomeBeforeExtraAndOT",
      วันละ: "perDay",
      ชั่วโมงละ: "perHour",
      ชม_OT_รวม: "OT",
      เงิน_OT_รวม: "OTAmount",
      รวมรายรับอื่นๆ: "totalAddIncome",
      วันหยุดพิเศษ: "extraHoliday",
      รายได้วันหยุดพิเศษ: "extraHolidayAmount",
      รวมรายได้: "incomeBeforeExpenses",
      ชม_ลา_รวม: "leaveAmount",
      หักเงินลา_รวม: "leaveAmountEvent",
      ลาไม่หักเงิน: "leaveUncut",
      ชม_ขาด_รวม: "absentAmount",
      หักเงินขาด_รวม: "absentAmountEvent",
      สาย_รวม: "totalLate",
      หักเงินสาย_รวม: "lateAmount",
      ออกก่อน_รวม: "totalOB",
      หักออกก่อน_รวม: "outBeforTimeAmount",
      ประกันสังคม: "insuranceAmount",
      ภาษี: "vatAmount",
      รายละเอียดรายจ่าย: "notCheckInAmount",
      รวมรายจ่ายอื่นๆ: "totalAddExpenses",
      รวมหัก: "deductAmount",
      คงเหลือเงิน: "balanceAmount",
      ประเภทการจ่ายเงิน: "paymentType",
      เลขที่บัญชี: "bankcode",
    },
    selectitems: [
      { txt: "None", val: "" },
      { txt: "ThisMount", val: 0 },
      { txt: "ThisWeek", val: 1 },
      { txt: "Today", val: 2 },
      { txt: "LastWeek", val: 3 },
      { txt: "LastMount", val: 4 },
    ],
    ChoiceSelected: "",
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
    buttonlist: 0,
    table_head_count: 1,
    pageActive: 1,
    delDialogStatus: false,
    from_date: "",
    to_date: "",
    delDialog: {
      roworder: "",
      name: "",
      emp_code: "",
      date: "",
    },
    snackbar: false,
    snackmsg: "",
    snack_type: "",
    responvalue: "",
    showbodyhtml: "",
    showheadhtml: "",
    bodyHtml: "",
    footerHtml: "",
    workhour_rate: [],
    ot_rate: [],
    absent_rate: [],
    leave_rate: [],
    ob_rate: [],
    ot_value: [],
    otobj: [],
    headReceive: [],
    headExpenses: [],
    earningDetailName: "",
    responvalue: [],
    late_rate: [],
    income: "",
    expenses: "",
    emp_code: localStorage._empcode,
    //emp_code: "EMP-016",
    listperson: [],
    listpersondetail: [],
    checkedValue: 0,
    checkboxperson: [],
    panel: 0,
    isCheck: true,
    count: 0,
    progressbar: {
      value: 0,
      query: false,
      show: false,
      msg: "",
    },
    emp_select: [],
    email_payslip: {
      doc: "",
      src: "",
      ltdName: " ",
      empcode: "",
      email: "",
      jsonData: [],
      income: "",
      incomeAmount: "",
      expenses: "",
      expensesAmount: "",
      space: "",
      spaceexpenses: "",
      spaceincome: "",
      data: null,
      pdfDocGen: null,
      header_table: [
        {
          text: "#",
        },
        {
          text: "รายการ",
        },
        {
          text: "หน่วยนับ",
        },
        {
          text: "จำนวน",
        },
      ],
    },
  }),
  created: function() {
    this.getPermissionEdit("CheckSalary");
    console.log("d23163d:", this.checkPermissionEdit);
    this.setShowFilter({
      status: 2,
    });

    this.$store.watch(
      (state) => {
        state.filter.SelectBranch;
        state.filter.SelectDepartment;
        state.filter.SelectPosition;
        state.filter.SearchData;
      },
      () => {},
      {
        deep: true,
      }
    );
    //this.process();
    //this.select();
    this.checksalary(this.emp_code);
    console.log("emp_code: " + localStorage._usercode);
  },
  destroyed: function() {
    this.commitToggleAlertDialog({
      status: false,
      message: Object,
    });
  },
  components: {
    Empimage,
  },
  computed: {
    ...mapState("filter", ["Branch_List", "Department_List", "Position_List", "Errormsg", "SelectBranch", "SelectDepartment", "SelectPosition", "SearchData"]),
    ...mapState("app", ["showLoading"]),
    ...mapState("permissionmenu", ["checkPermissionEdit"]),
    branchSelect: {
      get() {
        return this.SelectBranch;
      },
      async set(value) {
        await this.getDepartment({ branch: value });
      },
    },
    departmentSelect: {
      get() {
        return this.SelectDepartment;
      },
      async set(value) {
        await this.getPosition({ department: value });
      },
    },
    positionSelect: {
      get() {
        return this.SelectPosition;
      },
      async set(value) {
        await this.selectedPosition({ data: value });
      },
    },
  },
  methods: {
    ...mapMutations("filter", ["setShowFilter", "selectedFormDate", "selectedto_date", "getAllEmployeeByBranch", "selectedPosition"]),
    ...mapActions("app", ["commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    ...mapActions("permissionmenu", ["getPermission", "getPermissionEdit"]),
    ...mapMutations("permissionmenu", ["getCheckPermission", "getAllPermission"]),
    saveDoc() {
      let searchVal = "";
      let department = "";
      this.commitSetShowLoading(true);
      if (this.SearchData == undefined) {
        searchVal = "";
      } else {
        searchVal = this.SearchData;
      }
      if (this.SelectDepartment == "All" || this.SelectDepartment == "") {
        department = "";
      } else {
        department = this.SelectDepartment;
      }
      console.log(this.payroll_doc);
      PayrollService.createPayrollDoc(
        searchVal,
        this.payroll_doc.doc_no,
        this.payroll_doc.doc_date,
        this.payroll_doc.begin_date,
        this.payroll_doc.end_date,
        this.SelectBranch,
        department,
        this.payroll_doc.remark
      )
        .then((res) => {
          this.commitSetShowLoading(false);
          this.snackbarcolor = "success";
          this.snackmsg = "สร้างเอกสารจ่ายเงินสำเร็จ";
          this.snackbar = true;
          this.docDialog = false;
        })
        .catch((err) => {
          this.commitSetShowLoading(false);
          this.snackbarcolor = "error";
          this.snackmsg = "เอกสารเดือนนี้ถูกสร้างแล้ว";
          this.snackbar = true;
          this.docDialog = false;
        });
    },

    _today() {
      var d = new Date();

      var month = d.getMonth() + 1;
      var day = d.getDate();

      var output = d.getFullYear() + "-" + (month < 10 ? "0" : "") + month + "-" + (day < 10 ? "0" : "") + day;

      return output;
    },

    _docno(head) {
      return (
        head +
        "-xxx".replace(/[xy]/g, function(c) {
          var r = (Math.random() * 8) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        })
      );
    },
    _docdate() {
      var d = new Date();

      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hour = d.getHours();
      var min = d.getMinutes();

      var output = d.getFullYear() + "" + (month < 10 ? "0" : "") + month + "" + (day < 10 ? "0" : "") + day + hour + min;

      return output;
    },

    selectedformatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    selectedformatDates(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("/");
    },
    process() {
      if (this.from_date == "" || this.to_date == "") {
        this.snackbar = true;
        this.snackmsg = "กรุณาเลือกสาขาและวันที่";
      } else {
        this.commitSetShowLoading(true);
        let searchVal = "";
        if (this.SearchData == undefined) {
          searchVal = "";
        } else {
          searchVal = this.SearchData;
        }
        console.log("search : " + this.SearchData);
        ProcessService.getSalaryTable(this.SelectBranch, this.SelectDepartment, this.SelectPosition, searchVal, this.from_date, this.to_date);
      }
    },

    thousandSep(nStr) {
      //nStr = nStr.toFixed(2);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },

    onHandleDialog(status, save_type, data) {
      this.dialog_data = {
        status: status,
        save_type: save_type,
        data: data,
      };
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    formatNumber(value, digit, hasComma) {
      return Utils.formatNumber(value, digit, hasComma);
    },
    formatDate(newDate, format_type) {
      return Utils.formatDate(newDate, format_type);
    },
    dateformat(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    doCopyTable() {
      let el = document.getElementById("table_detail");
      let body = document.body;
      let range;
      let sel;
      if (document.createRange && window.getSelection) {
        range = document.createRange();
        sel = window.getSelection();
        sel.removeAllRanges();
        try {
          range.selectNodeContents(el);
          sel.addRange(range);
        } catch (e) {
          range.selectNode(el);
          sel.addRange(range);
        }
      }
      document.execCommand("Copy");
      alert("Copy Table to Clipboard");
    },

    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then((res) => {
          this.branch_items = res.data.content;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProfileDepartmentList() {
      SettingService.getProfileDepartmentList()
        .then((res) => {
          this.department_items = res.data.content;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteItem(data) {
      this.delDialog.roworder = data.roworder;
      this.delDialog.name = data.name;
      this.delDialog.emp_code = data.firstName + " " + data.lastName;
      this.delDialog.date = data.add_date;
      this.delDialogStatus = true;
    },
    onDelete() {
      DocumentService.deleteExpenses(this.delDialog.roworder)
        .then((res) => {
          this.table_datalist_resign;
          this.delDialogStatus = false;
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        });
    },
    // แสดงตารางก่อน download
    checkbutton(buttonlist, type) {
      if (buttonlist == 1 && type == "display") {
        this.buttonlist = 1;
        console.log("table");
      } else if (buttonlist == 0 && type == "display") {
        this.buttonlist = 0;
        console.log("list");
      } else if (buttonlist == 1 && type == "downloadexcel") {
        this.buttonlist = 1;
        setTimeout(() => {
          this.checkstatus("downloadexcel");
        }, 300);
        console.log("downloadexcel");
      } else if (buttonlist == 1 && type == "doCopyTable") {
        this.buttonlist = 1;
        setTimeout(() => {
          this.checkstatus("doCopyTable");
        }, 300);
        console.log("doCopyTable");
      }
    },

    checkstatus(type) {
      let v = this;
      if (type == "downloadexcel") {
        v.downloadexcel();
      }
      if (type == "doCopyTable") {
        v.doCopyTable();
      }
    },
    checksalary(emp_code) {
      PayrollService.getDocDetailByEmp(emp_code)
        .then((res) => {
          console.log(res.data);
          this.listperson = [];
          this.listpersondetail = [];

          this.listperson = res.data;
          this.listperson.forEach((element) => {
            this.listpersondetail.push(element);
          });
          console.log(this.listpersondetail);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showPayslip(docno, empcode) {
      window.open("#/PeviewPDF/" + docno + "/" + empcode, "_blank");
      //console.log("docno"+this.docno);
      console.log("empcode" + empcode);
    },

    emailPayslip(empcode, index) {
      this.progressbar.msg = this.load_msg;
      this.progressbar.query = true;
      this.progressbar.show = true;
      this.progressbar.value = 0;
      this.dialog_loading = true;
      let arr = [];
      let rowz = this.listpersondetail.filter((c) => c.code == empcode);
      if (rowz.length > 0) {
        arr.push(rowz[index]);
      }
      console.log(rowz);
      //arr.push(empcode);
      this.emp_select = arr;
      this.getCompany();
      console.log(this.emp_select);
    },
    async getCompany() {
      NProgress.start();
      try {
        let tmpResult = await SettingService.getDataCompany();
        this.email_payslip.ltdName = tmpResult.data.content[0].companyname;
        setTimeout(() => {
          this.getPDFByEmpID();
        }, 1000);
      } catch (err) {
        console.log(err);
        this.progressbar.msg = this.load_msg;
        this.progressbar.query = false;
        this.progressbar.show = false;
        this.progressbar.value = 0;
        this.dialog_loading = false;
      }
      NProgress.done();
    },
    async getPDFByEmpID() {
      let v = this;
      NProgress.start();
      this.send_email = [];
      this.progressbar.msg = this.send_msg;
      this.progressbar.query = false;
      try {
        let tmpResult = this.emp_select;
        console.log(tmpResult);
        // gen items
        await tmpResult.forEach(async function(element, index) {
          v.progressbar.value = 100;
          if (element.email != null) {
          if (element.email.length > 0) {
            var code = element.code; //รหัสพนักงาน
            var name = element.name.split("(")[0]; //ชื่อพนักงาน
            var date = moment(element.processTimes[element.processTimes.length - 1].date).format("DD/MM/YYYY"); //วันที่
            var email = element.email;
            var departmentname = element.department_name; //ตำแหน่ง
            var salary = v.thousandSep(element.salary); //เงินเดือน
            var deductSS = v.thousandSep(element.deductSS); //รายได้สุทธิ
            var total_balance = v.thousandSep(element.total_balance); //รายได้สุทธิ
            var accumulatedIncome = v.thousandSep(element.accumulatedIncome); //รายได้สะสม
            var cumulativeSS = v.thousandSep(element.cumulativeSS); //ประกันสะสม
            var cumulativeTax = v.thousandSep(element.cumulativeTax); //ภาษีสะสม
            var totalEarning = v.thousandSep(element.totalEarning); //รายได้รวม
            var totalDeduct = v.thousandSep(element.totalDeduct); //รวมรายจ่าย
            var incomeAndExpenses = element.incomeAndExpenses; //รวมรายจ่ายและรายได้
            var deduct_tax = v.thousandSep(element.deduct_tax); //ภาษี
            var income = "";
            var incomeAmount = "";
            var expenses = "";
            var expensesAmount = "";
            var spaceexpenses = "";
            var spaceincome = "";
            var space = "";
            for (let index = 0; index < incomeAndExpenses.length; index++) {
              if (incomeAndExpenses[index].tranFlag === 0) {
                income += `\n` + incomeAndExpenses[index].name;
                incomeAmount += `\n` + v.thousandSep(incomeAndExpenses[index].amount);
                spaceincome += `\n`;
              } else if (incomeAndExpenses[index].tranFlag === 1) {
                expenses += `\n` + incomeAndExpenses[index].name;
                expensesAmount += `\n` + v.thousandSep(incomeAndExpenses[index].amount);
                spaceexpenses += `\n`;
              } else if (incomeAndExpenses[index].tranFlag !== 0 && incomeAndExpenses[index].tranFlag !== 1) {
                space += "";
              }
            }

            if (deduct_tax !== "0.00") {
              expenses += `\nภาษี`;
              expensesAmount += `\n` + deduct_tax;
              spaceexpenses += `\n`;
            }

            let jsonData = v.genSlipJson(
              "none",
              v.email_payslip.ltdName,
              code,
              date,
              name,
              spaceincome,
              departmentname,
              space,
              spaceexpenses,
              total_balance,
              totalEarning,
              income,
              salary,
              incomeAmount,
              totalDeduct,
              expenses,
              deductSS,
              expensesAmount,
              accumulatedIncome,
              cumulativeTax,
              cumulativeSS
            );

            var pdfMake = require("pdfmake/build/pdfmake.js");
            //pdfMake.setFonts(fonts);
            pdfMake.fonts = {
              Sarabun: {
                normal: "https://fonts.gstatic.com/s/sarabun/v12/DtVjJx26TKEr37c9WBJDnlQN9gk.ttf",
                bold: "https://fonts.gstatic.com/s/sarabun/v12/DtVmJx26TKEr37c9YK5sulwm6gDXvwE.ttf",
                italics: "https://fonts.gstatic.com/s/sarabun/v12/DtVhJx26TKEr37c9aBBJmnYI5gnOpg.ttf",
                bolditalics: "https://fonts.gstatic.com/s/sarabun/v12/DtVkJx26TKEr37c9aBBxJlks7iLSrwFUlw.ttf",
              },
            };
            // if (pdfMake.vfs == undefined) {
            //   var pdfFonts = require("pdfmake/build/vfs_fonts.js");
            //   pdfMake.vfs = pdfFonts.pdfMake.vfs;
            // }

            // pdfMake.fonts = {
            //   THSarabunNew: {
            //     normal: "THSarabunNew.ttf",
            //     bold: "THSarabunNew-Bold.ttf",
            //     italics: "THSarabunNew-Italic.ttf",
            //     bolditalics: "THSarabunNew-BoldItalic.ttf"
            //   },
            //   Roboto: {
            //     normal: "Roboto-Regular.ttf",
            //     bold: "Roboto-Medium.ttf",
            //     italics: "Roboto-Italic.ttf",
            //     bolditalics: "Roboto-MediumItalic.ttf"
            //   }
            // };

            let docDefinition = {
              content: jsonData,
              styles: {
                header: {
                  fontSize: 20,
                  bold: true,
                  margin: [0, 0, 0, 3],
                },
                subheader: {
                  fontSize: 16,
                  bold: true,
                },
              },
              defaultStyle: {
                font: "Sarabun",
                fontSize: 14,
              },
            };
            v.email_payslip.pdfDocGen = "";
            v.email_payslip.pdfDocGen = pdfMake.createPdf(docDefinition);
            await v.email_payslip.pdfDocGen.getDataUrl((data) => {
              //console.log("email " + email);
              var detail = data.replace("data:application/pdf;base64,", "");
              v.send_email.push({
                email: email,
                slip_date: date,
                name: name,
                shopname: localStorage._company_name,
                data: detail,
              });
            });
          }
          }
        });
        //console.log(this.send_email);
        setTimeout(() => {
          v.postSendEmail();
        }, 1000);
      } catch (err) {
        console.log(err);
        this.progressbar.msg = this.load_msg;
        this.progressbar.query = false;
        this.progressbar.show = false;
        this.progressbar.value = 0;
        this.dialog_loading = false;
      }
      NProgress.done();
    },
    postSendEmail() {
      console.log("sending");
      console.log(this.send_email);

      PayrollService.postSendEmail(this.send_email)
        .then((res) => {
          console.log(res);
          this.progressbar.msg = this.load_msg;
          this.progressbar.query = false;
          this.progressbar.show = false;
          this.progressbar.value = 0;
          this.dialog_loading = false;
          this.snackbar = true;
          this.snack_type = "success";
          this.snackmsg = "Send email success";
        })
        .catch((err) => {
          console.log(err);
          this.progressbar.msg = this.load_msg;
          this.progressbar.query = false;
          this.progressbar.show = false;
          this.progressbar.value = 0;
          this.dialog_loading = false;
          this.snackbar = true;
          this.snack_type = "error";
          this.snackmsg = "Send email error";
        });
    },
    genSlipJson(
      param,
      ltdName,
      code,
      date,
      name,
      spaceincome,
      departmentname,
      space,
      spaceexpenses,
      total_balance,
      totalEarning,
      income,
      salary,
      incomeAmount,
      totalDeduct,
      expenses,
      deductSS,
      expensesAmount,
      accumulatedIncome,
      cumulativeTax,
      cumulativeSS
    ) {
      let jSonResult = [
        {
          columns: [
            {
              text: ltdName,
              style: "header",
              alignment: "center",
              pageBreak: param,
            },
          ],
        },
        {
          columns: [
            {
              text: "ใบจ่ายเงินเดือน",
              style: "header",
              alignment: "center",
            },
          ],
        },
        {
          columns: [
            {
              text: "รหัสพนักงาน:" + code,
              style: "subheader",
              alignment: "left",
            },
          ],
        },
        {
          columns: [
            {
              width: 150,
              table: {
                widths: [70, 70],
                headerRows: 1,
                body: [
                  [
                    {
                      text: "วันที่ : " + date + "\n" + "ชื่อ :" + name + "\n\n" + spaceincome + "แผนก :" + departmentname + "\n\n\n" + space + spaceexpenses,
                      margin: [0, 0, 0, 15],
                      colSpan: 2,
                    },
                    { text: "" },
                  ],

                  [{ text: "รายได้สุทธิ", alignment: "center" }, { text: "ผู้รับเงิน", alignment: "center" }],
                  [{ text: total_balance, alignment: "center" }, { text: "____________", alignment: "center" }],
                ],
              },
            },
            {
              width: 250,
              margin: [15, 0, 0, 0],
              table: {
                widths: [80, 10, 60, 100, 60],
                headerRows: 1,
                body: [
                  [
                    { text: "รายได้", colSpan: 4, alignment: "center" },
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    {
                      text: "รายได้รวม" + "\n\n" + spaceincome + totalEarning,
                      rowSpan: 2,
                      alignment: "center",
                    },
                  ],
                  [
                    { text: "เงินเดือน" + income },
                    {
                      text: salary + incomeAmount + "\n\n",
                      colSpan: 3,
                    },
                  ],
                  [
                    { text: "รายจ่าย", colSpan: 4, alignment: "center" },
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    {
                      text: "รวมรายจ่าย" + "\n\n" + spaceexpenses + totalDeduct,
                      rowSpan: 2,
                      alignment: "center",
                    },
                  ],
                  [
                    { text: "ประกันสังคม" + expenses },
                    {
                      text: deductSS + expensesAmount + "\n\n",
                      colSpan: 3,
                    },
                  ],
                  [
                    { text: "รายได้สะสม", colSpan: 2, alignment: "center" },
                    { text: "" },
                    { text: "ภาษีสะสม", alignment: "center" },
                    { text: "เงินประกันสังคมสะสมต่อปี", alignment: "center" },

                    { text: "รายได้สุทธิ", alignment: "center" },
                  ],
                  [
                    {
                      text: accumulatedIncome,
                      colSpan: 2,
                      alignment: "center",
                    },
                    { text: "" },
                    { text: cumulativeTax, alignment: "center" },
                    { text: cumulativeSS, alignment: "center" },

                    { text: total_balance, alignment: "center" },
                  ],
                ],
              },
            },
          ],
        },
      ];
      return jSonResult;
    },
    select() {
      //this.checkboxperson= [];

      // for(let i  in this.listpersondetail){
      //     this.checkboxperson.push(this.listpersondetail[i].docNo);
      //     count= i++;
      //     console.log("select" + this.checkboxperson.length);
      // }
      //   console.log("count" + count);

      if (this.checkboxperson.length > 0) {
        this.count = 1;
      } else {
        this.count = 0;
      }
      console.log("count" + this.count);
      console.log("checkboxperson" + this.checkboxperson.values());
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

h2,
h3,
span,
p {
  font-family: "Prompt", sans-serif;
}
.border {
  border: 1px black solid;
}
.scroll-area {
  position: relative;
  width: 100%;
  height: 440px;
  margin-bottom: 30px;
}

/* mobile  ----------- */
@media screen and (min-width: 320px) and (max-width: 640px) {
  #header_message {
    visibility: hidden;
    clear: both;
    float: left;
    width: 28%;
    display: none;
    margin-right: 0px !important;
  }
  .container-fluid {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .display_none1 {
    display: none;
  }
}

/* tablet  ----------- */
@media screen and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
}

/* ipad pro  ----------- */
@media screen and (min-width: 1024px) and (max-width: 1366px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
}

@media screen and (min-width: 1024px) and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}

/* iPads (landscape) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1020px) and (orientation: landscape) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
/* iPads (portrait) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
@media only screen and (min-device-width: 772px) and (max-device-width: 1020px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
</style>
